import { cn } from "@gymflow/helpers";
import { useInfiniteQuery } from "@tanstack/react-query";
import { apiV2 } from "libs/api/src/lib/apiV2";
import { DateTime } from "luxon";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "../../../atoms";
import HostedPagesClassCard from "../../../site/HostedPagesClasses/components/HostedPagesClassCard";
import { AppSettingsContext } from "../components/AppSettingsContext";

export const AppSettingsClassPreview = ({
  className,
}: {
  className?: string;
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useInfiniteQuery(
    apiV2.staff.eventOccurrence.infiniteQueries.list({
      limit: 1,
      dateFrom: DateTime.now().startOf("hour").toISO()!,
      dateTo: DateTime.now().plus({ days: 1 }).startOf("hour").toISO()!,
    }),
  );
  const currentClass = data?.pages.flatMap((page) => page.content)[0];
  const { classesSettings } = useContext(AppSettingsContext);
  if (!classesSettings) return null;
  return (
    <div
      className={cn(
        "flex size-full items-center justify-center rounded-3xl bg-gray-100 p-6",
        className,
      )}
    >
      {isLoading && <Spinner />}
      {!isLoading && !currentClass && (
        <div className="flex flex-col items-center justify-center font-bold text-gray-950">
          {t("page.settings.appSettings.classes.noClassFound")}
        </div>
      )}
      {currentClass && (
        <HostedPagesClassCard
          calendarEventOccurrence={{
            ...currentClass,
            bookedCount: Math.max((currentClass.capacity ?? 0) - 2, 0),
          }}
          disabled
          classesCapacityShowMode={classesSettings.classesCapacityShowMode}
          className="w-full max-lg:max-w-md"
        />
      )}
    </div>
  );
};
